// extracted by mini-css-extract-plugin
module.exports =  {"container":"_02712f2b3b--container--Mc5aa","rating":"_02712f2b3b--rating--v2Lek","details":"_02712f2b3b--details--z2NmG","invisible":"_02712f2b3b--invisible--WyKOr"};